import { render, staticRenderFns } from "./BankMovementsRelations.vue?vue&type=template&id=8217708a&"
import script from "./BankMovementsRelations.vue?vue&type=script&lang=js&"
export * from "./BankMovementsRelations.vue?vue&type=script&lang=js&"
import style0 from "./BankMovementsRelations.vue?vue&type=style&index=0&id=8217708a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports